var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackrecttickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 4791,
    transform: "translate(-521 -2872)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -521,
    y: -2298,
    width: 1366,
    height: 4217,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -413,
    y: -861,
    width: 762,
    height: 909,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -93.5,
    y: -19.5,
    width: 124,
    height: 51,
    rx: 5.5,
    fill: "white",
    stroke: "#EAEDF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 11.2,
    height: 11.2,
    rx: 1.6,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6H3",
    stroke: "#200E32",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9V3",
    stroke: "#200E32",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 4791,
    fill: "white",
    transform: "translate(-521 -2872)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackrecttickIcon);
export default __webpack_public_path__ + "static/media/blackrecttickIcon.937e402f1c3f7461089c8fa0cec143d4.svg";
export { ForwardRef as ReactComponent };